<div class="header-bar">
  <h1>Handover Times</h1>
</div>
<div class="">
  <div class="content-container">
    <div class="card card-w-title">
      <div class="filters mb-3">
        Customer:
        <p-dropdown
          [(ngModel)]="organisationId"
          [options]="customerOptions"
          [style]="{'width':'300px'}"
          (onChange)="customerChanged()"
        ></p-dropdown>
      </div>

      <form [formGroup]="handoverForm" *ngIf="handoverTaskTypes">
        <table>
          <thead>
            <tr>
              <th>Task Type</th>
              <th>Pickup Handover</th>
              <th>Dropoff Handover</th>
            </tr>
          </thead>
          <tbody>
            <tr
              formArrayName="handoverTaskTypes"
              *ngFor="let taskType of handoverTaskTypes.controls; let i = index"
            >
              <td class="inputLabel">{{ taskType.get("name").value }}</td>
              <td [formGroupName]="i" class="pickupColumn">
                <input formControlName="pickupHandoverMinutes" pInputText class="timeInput" />
                minutes
              </td>
              <td [formGroupName]="i">
                <input formControlName="dropoffHandoverMinutes" pInputText class="timeInput" />
                minutes
              </td>
            </tr>
          </tbody>
        </table>

        <div class="text-right mt-2">
          <button pButton label="Cancel" (click)="editHandoverTime = false"></button>
          <button pButton label="Save" (click)="saveHandoverTimes()"></button>
        </div>
      </form>
    </div>
  </div>
</div>
